import { ICrystalDTO } from 'business/models/Models';
import { useCrystalsByRegion } from 'components/crystal/hooks';
import HeadingWithTextContent, {
  Props as IHeadingWithTextContentProps,
} from 'components/generic/headingWithTextContent';
import NodeInfoContainerPanel from 'components/sidePanel/projectSidePanel/NodeInfoContainerPanel';
import React, { useCallback, useMemo } from 'react';
import {
  AttachmentContent,
  CryoprotectantContent,
  NotesContent,
  SoakingContent,
} from './infoComponents';

interface Props {
  regionId: number;
}

const getCrystalNodeMenuDetails = (crystal: ICrystalDTO) => {
  const nodeMenuDetails = [
    { labelName: 'Crystals ID', info: crystal.id },
    { labelName: 'Crystal Name', info: crystal.name },
    { labelName: 'Protein Name', info: crystal.projectName },
    { labelName: 'Barcode, Well & Drop', info: crystal.barcode },
    { labelName: 'Trip Name', info: crystal.synchTripName },
    {
      labelName: 'Date Frozen',
      info: `${
        crystal.dateFrozen?.getMonth() + 1
      }/${crystal.dateFrozen?.getDate()}/${crystal.dateFrozen?.getFullYear()}`,
    },
  ];
  return nodeMenuDetails;
};

export const CrystalsInfo = (props: Props) => {
  const { regionId } = props;
  const { crystals } = useCrystalsByRegion(regionId);

  const infoSections = useCallback(
    (crystal): IHeadingWithTextContentProps[] => [
      {
        heading: 'Cryoprotectant',
        content: <CryoprotectantContent crystal={crystal} />,
      },
      {
        heading: 'Soaking',
        content: <SoakingContent crystal={crystal} />,
      },
      {
        heading: 'Notes',
        content: <NotesContent crystal={crystal} />,
      },
      {
        heading: 'Attachment',
        content: <AttachmentContent crystal={crystal} />,
      },
    ],
    [],
  );

  const renderWellDropCrystals = useMemo(() => {
    return crystals.map((crystal: ICrystalDTO, index) => {
      return (
        <div id="crystalinfo-well-drop-wrapper" key={`crys_${index}`}>
          <NodeInfoContainerPanel
            nodeMenuDetails={getCrystalNodeMenuDetails(crystal)}
            header="Crystal Information"
            type={undefined}
            treeNodeId={undefined}
          />
          <div
            id="crystalinfo-well-drop-info-section"
            className="flex flex-col gap-[8px] pl-[8px] pt-[8px] pr-[8px]"
          >
            {infoSections(crystal).map((section, index) => (
              <HeadingWithTextContent
                key={`crystal_section_${index}`}
                heading={section.heading}
                content={section.content}
              />
            ))}
          </div>
        </div>
      );
    });
  }, [crystals]);

  return (
    <div id="crystalsinfo-main-container" className="flex flex-col gap-[25px]">
      {renderWellDropCrystals}
    </div>
  );
};

export default CrystalsInfo;
